module.exports = __webpack_public_path__ + "static/paris-012.thumb-47dc1120358adffa121511c559aa0ec6.jpg";